import connectedComponent from './PageNavOverlay';

export default connectedComponent;
